export const countryConfig = {
	europe: {
		andorra: {
			name: "Andorra",
			code: "AND"
		},
		albania: {
			name: "Albania",
			code: "ALB"
		},
		armenia: {
			name: "Armenia",
			code: "ARM"
		},
		austria: {
			name: "Austria",
			code: "AUT"
		},
		aland : {
			name: "Åland Islands",
			code: "ALA"
		},
		azerbaijan: {
			name: "Azerbaijan",
			code: "AZE"
		},
		bosniaAndHerzegovina: {
			name: "Bosnia and Herzegovina",
			code: "BIH"
		},
		belgium: {
			name: "Belgium",
			code: "BEL"
		},
		bulgaria: {
			name: "Bulgaria",
			code: "BGR"
		},
		belarus: {
			name: "Belarus",
			code: "BLR"
		},
		cyprus: {
			name: "Cyprus",
			code: "CYP"
		},
		czechRepublic: {
			name: "Czech Republic",
			code: "CZE"
		},
		denmark: {
			name: "Denmark",
			code: "DNK"
		},
		Estonia: {
			name: "Estonia",
			code: "EST"
		},
		faroeIslands: {
			name: "Faroe Islands",
			code: "FRO"
		},
		finland: {
			name: "Finland",
			code: "FIN"
		},
		france: {
			name: "France",
			code: "FRA"
		},
		georgia: {
			name: "Georgia",
			code: "GEO"
		},
		germany: {
			name: "Germany",
			code: "DEU"
		},
		guernsey: {
			name: "Guernsey",
			code: "GGY"
		},
		gibraltar: {
			name: "Gibraltar",
			code: "GIB"
		},
		greece: {
			name: "Greece",
			code: "GRC"
		},
		grvatska: {
			name: "Hrvatska",
			code: "HRV"
		},
		hungary: {
			name: "Hungary",
			code: "HUN"
		},
		ireland: {
			name: "Ireland",
			code: "IRL"
		},
		isleOfMan: {
			name: "Isle of Man",
			code: "IMN"
		},
		iceland: {
			name: "Iceland",
			code: "ISL"
		},
		italy: {
			name: "Italy",
			code: "ITA"
		},
		jersey: {
			name: "Jersey",
			code: "JEY"
		},
		kazakhstan: {
			name: "Kazakhstan",
			code: "KAZ"
		},
		liechtenstein: {
			name: "Liechtenstein",
			code: "LIE"
		},
		lithuania: {
			name: "Lithuania",
			code: "LTU"
		},
		luxembourg: {
			name: "Luxembourg",
			code: "LUX"
		},
		latvia: {
			name: "Latvia",
			code: "LVA"
		},
		monaco: {
			name: "Monaco",
			code: "MCO"
		},
		moldova: {
			name: "Moldova",
			code: "MDA"
		},
		montenegro: {
			name: "Montenegro",
			code: "MNE"
		},
		northMacedonia: {
			name: "North Macedonia",
			code: "MKD"
		},
		malta: {
			name: "Malta",
			code: "MLT"
		},
		netherlands: {
			name: "Netherlands",
			code: "NLD"
		},
		norway: {
			name: "Norway",
			code: "NOR"
		},
		poland: {
			name: "Poland",
			code: "POL"
		},
		portugal: {
			name: "Portugal",
			code: "PRT"
		},
		romania: {
			name: "Romania",
			code: "ROU"
		},
		russia: {
			name: "Russia",
			code: "RUS"
		},
		sanMarino: {
			name: "San Marino",
			code: "SMR"
		},
		serbia: {
			name: "Serbia",
			code: "SRB"
		},
		slovakia: {
			name: "Slovakia",
			code: "SVK"
		},
		slovenia: {
			name: "Slovenia",
			code: "SVN"
		},
		spain: {
			name: "Spain",
			code: "ESP"
		},
		svalbardAndJanMayen: {
			name: "Svalbard and Jan Mayen",
			code: "SJM"
		},
		sweden: {
			name: "Sweden",
			code: "SWE"
		},
		switzerland: {
			name: "Switzerland",
			code: "CHE"
		},
		turkey: {
			name: "Turkey",
			code: "TUR"
		},
		ukraine: {
			name: "Ukraine",
			code: "UKR"
		},
		unitedKingdom: {
			name: "United Kingdom",
			code: "GBR"
		},
		vatican: {
			name: "Vatican",
			code: "VAT"
		}
	}
}